export default {
  newVersion: {
    updated: "HelixScan se ha actualizado a {version}",
    reload: "Recargar",
  },
};
